import React, { useState, useEffect } from "react";
import { FaSearch} from "react-icons/fa";
import Header from "../Common/AdminHeader";
import AcceptingTrainerCard from "../../../Shared components/AcceptingTrainerCard";
import axios from "axios";
import { Config } from "../../../API/config";
import { AdminTrainer } from "../../../types/AdminTypes";
// MangeTrainers
const MangeUsers = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [trainers, setTrainers] = useState<AdminTrainer[]>([]);
    const [filteredTrainers, setFilteredTrainers] = useState<AdminTrainer[]>([]); // New state for filtered trainers

    const getAllPendingTrainers = async () => {
        try {
            setLoading(true);
            let { data } = await axios.get(Config.getAllPendingTrainers, { withCredentials: true });


            if (data.statusCode === 200) {
                setTrainers(data.data);
                setFilteredTrainers(data.data); 
            }
        } catch (err) {
            console.error("Error fetching Messages data:", err);
            setTrainers([]);
            setFilteredTrainers([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAllPendingTrainers();
    }, []);

    const handleSearch = (query: string) => {
        setSearchTerm(query);
        if (query.trim() === "") {
            setFilteredTrainers(trainers); 
        } else {
            const filtered = trainers.filter((trainer) =>
                (trainer.name?.toLowerCase().includes(query.toLowerCase()) ||
                trainer.email?.toLowerCase().includes(query.toLowerCase()) ||
                trainer.phone?.includes(query))
            );
            setFilteredTrainers(filtered);
        }
    };

    return (
        <div className="flex-1 overflow-auto relative z-10 bg-white">
            <Header title="قبول المدربين" />
            <main className="max-w-80 md:max-w-7xl mx-auto md:py-6 md:px-4 lg:px-8 overflow-auto">
                <div className="relative mb-4 flex justify-end">
                    <input
                        type="text"
                        placeholder="ابحث عن مدرب..."
                        className="w-full md:w-1/2 p-2 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-right" // Added pr-10 for icon spacing and text-right for RTL
                        value={searchTerm}
                        onChange={(e) => handleSearch(e.target.value)} // Updated to use handleSearch
                    />
                    <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {loading ? (
                        <p className="text-center text-gray-500">جاري التحميل...</p>
                    ) : filteredTrainers.length > 0 ? (
                        filteredTrainers.map((trainer, idx) => (
                            <AcceptingTrainerCard
                                trainer={trainer}
                                update={getAllPendingTrainers}
                                key={idx}
                            />
                        ))
                    ) : (
                        <p className="text-center text-gray-500">لا يوجد مدربين مطابقين</p>
                    )}
                </div>
            </main>
        </div>
    );
};

export default MangeUsers;